import React, { memo, forwardRef } from "react";
import PropTypes from "prop-types";
import { Alert as ChakraAlert, Icon } from "@chakra-ui/react";
import {ALERT_STYLES} from "@simplified-workspace/shared/util-theme";

const AlertIcon = ({ status }) => (
  <Icon
    as={ALERT_STYLES[status]?.icon}
    color={ALERT_STYLES[status]?.color}
    w="6"
    h="6"
    mr="2"
  />
);

const Alert = forwardRef(({ status, showIcon, children, ...props }, ref) => (
  <ChakraAlert
    {...props}
    sx={{
      background: ALERT_STYLES[status]?.background,
      color: ALERT_STYLES[status]?.color,
      ...props.sx,
    }}
    ref={ref}
  >
    {showIcon ? <AlertIcon status={status} /> : null}
    {children}
  </ChakraAlert>
));

Alert.propTypes = {
  status: PropTypes.oneOf(Object.keys(ALERT_STYLES)),
  showIcon: PropTypes.bool,
};

Alert.defaultProps = {
  status: "info",
  showIcon: undefined,
};

export default memo(Alert);
